const NotesSpecReviewWizard = ({ setComment, comment }: any) => {
  return (
    <div className='row'>
      <div className='col-md-12'>
        <label>Comments </label>
        <textarea
          className="form-control"
          rows={5}
          style={{ width: '100%' }}
          value={comment}
          onChange={(e: any) => setComment(e.target?.value)}
        />
      </div>
    </div>
  )
}

export default NotesSpecReviewWizard